









import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    ApexChart: () => import('vue-apexcharts')
  },
  props: {
    height: {
      type: Number,
      required: false,
      default: 200
    },
    plot: {
      type: Object,
      required: true
    },
    intValues: {
      type: Boolean,
      required: false,
      default: false
    },
    fixed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    xAxis() {
      return this.plot.xAxis || this.plot.x_axis
    },
    yAxles() {
      return this.plot.yAxles || this.plot.y_axles
    },
    chartSeries() {
      return this.yAxles.map(axis => {
        return {
          name: axis.label,
          data: axis.values
        }
      })
    },
    chartOptions() {
      return {
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        chart: {
          toolbar: this.plot.toolbar || { show: false },
          height: '200px',
          type: 'area',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          zoom: this.plot.zoom || {
            enabled: false
          },
          events: {
            animationEnd: () => {
              this.$emit('animation-end')
            }
          }
        },
        stroke: {
          width: 2,
          curve: 'smooth'
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: this.plot.xAxis.type || undefined,
          tooltip: {
            enabled: false
          },
          labels: this.plot.xAxis.labels || {
            show: false
          },
          categories: this.xAxis.values.map(value => value.label),
          min: this.plot.xAxis.min || undefined,
          max: this.plot.xAxis.max || undefined
        },
        tooltip: {
          fixed: {
            enabled: this.fixed,
            position: 'topRight',
            offsetY: -20
          }
        },
        yaxis: {
          tickAmount: 3,
          labels: {
            formatter: (val: string | number) => {
              if (val && this.intValues) {
                return (val as number).toFixed(0)
              }
              return val
            }
          }
        },
        legend: this.plot.legend || {
          show: true
        }
      }
    }
  }
})
